module.exports = __webpack_public_path__ + "media/images/lb/852-8de97a6ec2767590f2a1dd08d2edba6a.svg";